import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../axiosConfig';
import { Box, Heading, useToast } from '@chakra-ui/react';
import SurveyPeriodForm from './SurveyPeriodForm';

const SurveyPeriodCreatePage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const handleCreate = async (formData) => {
    setIsSubmitting(true);
    try {
      await axios.post('/survey_periods', formData);
      toast({
        title: 'Survey period created successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      navigate('/app/survey_periods');
    } catch (error) {
      console.error('Error creating survey period:', error);
      toast({
        title: 'Failed to create survey period.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box px={6} py={8}>
      <Heading as="h2" size="lg" mb={6} textAlign="center">
        Create Survey Period
      </Heading>
      <SurveyPeriodForm onSubmit={handleCreate} isSubmitting={isSubmitting} />
    </Box>
  );
};

export default SurveyPeriodCreatePage;